import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = () => ({
  total: 0,
  items: [],
  success: false,
  successServer: true,
  cartState: 'LOADING'
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};